"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.sampleQuestions = void 0;
var React = __importStar(require("react"));
var question_to_show_1 = __importDefault(require("../components/question-to-show"));
var use_question_1 = __importDefault(require("../hooks/use-question"));
var router_1 = require("next/router");
var keys_1 = __importDefault(require("lodash/keys"));
var get_1 = __importDefault(require("lodash/get"));
var link_1 = __importDefault(require("next/link"));
var Answer = function (_a) {
    var config = _a.config, questionSet = _a.questionSet, syntaxHighlighterTheme = _a.syntaxHighlighterTheme, children = _a.children;
    var router = (0, router_1.useRouter)();
    var _b = React.useState(), currentQuestion = _b[0], setCurrentQuestion = _b[1];
    var _c = React.useState(), currentAnswer = _c[0], setCurrentAnswer = _c[1];
    React.useEffect(function () {
        var currentQuestionId = (0, get_1["default"])(router.query, 'question', '');
        var currentQuestion = (0, get_1["default"])(questionSet, currentQuestionId);
        setCurrentQuestion(currentQuestion);
        var currentAnswer = (0, get_1["default"])(router.query, 'a');
        setCurrentAnswer(currentAnswer);
    }, [router, questionSet]);
    var question = (0, use_question_1["default"])({
        currentQuestion: currentQuestion,
        questionSet: questionSet,
        config: config,
        currentAnswer: currentAnswer,
        syntaxHighlighterTheme: syntaxHighlighterTheme
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-sr-quiz": question.isAnswered ? 'answered' : '' },
            question.currentQuestion && (0, question_to_show_1["default"])(question),
            children,
            React.createElement(DevTools, { questionSet: questionSet }))));
};
exports.sampleQuestions = {
    essay: {
        question: "## Lorem ipsum dolor sit amet?",
        type: "essay",
        tagId: 0
    },
    trueFalse: {
        question: "## True or false: Lorem ipsum dolor sit amet?",
        type: "multiple-choice",
        tagId: 0,
        correct: 'true',
        answer: "Yes! Lorem ipsum!",
        choices: [
            {
                answer: 'true',
                label: 'Yes'
            },
            {
                answer: 'false',
                label: 'No'
            },
        ]
    },
    multipleCorrect: {
        question: "## Lorem ipsum dolor sit amet?",
        type: "multiple-choice",
        tagId: 0,
        correct: ['one', 'two'],
        answer: "Yes! Lorem ipsum!",
        choices: [
            {
                answer: 'one',
                label: 'One'
            },
            {
                answer: 'two',
                label: 'Two'
            },
            {
                answer: 'three',
                label: 'Three'
            },
            {
                answer: 'four',
                label: 'Four'
            },
        ]
    }
};
var DevTools = function (_a) {
    var questionSet = _a.questionSet;
    var _b = React.useState(false), hidden = _b[0], setHidden = _b[1];
    var router = (0, router_1.useRouter)();
    if (process.env.NODE_ENV !== 'development' || hidden) {
        return null;
    }
    return (React.createElement("nav", { className: "z-10 flex border border-gray-100 dark:border-gray-700 flex-col fixed bottom-5 right-5 rounded-md bg-white dark:bg-gray-800 shadow-xl p-4 sm:visible invisible" },
        React.createElement("div", { className: "w-full flex leading-tighter justify-end absolute right-2 top-2" },
            React.createElement("button", { onClick: function () { return setHidden(true); }, className: "text-xs text-black dark:text-white font-bold" },
                React.createElement("span", { className: "not-sr-only" }, "\u2715"),
                React.createElement("span", { className: "sr-only" }, "close navigation"))),
        React.createElement("span", { className: "text-sm font-medium pb-2 text-indigo-600 dark:text-indigo-200" }, "Questions:"),
        React.createElement("ul", { className: "list-decimal list-inside" }, (0, keys_1["default"])(questionSet).map(function (q) { return (React.createElement("li", { className: "pb-1", key: q },
            React.createElement(link_1["default"], { href: {
                    pathname: router.pathname,
                    query: {
                        question: q
                    }
                } },
                React.createElement("a", { className: (0, get_1["default"])(router.query, 'question') === q
                        ? 'underline'
                        : 'hover:underline' }, q)))); }))));
};
exports["default"] = Answer;
